import { Position } from '@models/map/Position'
import { Extent } from './Extent'
import { BookmarkType } from '@models/bookmark/BookmarkFactory'
export interface Bookmark {
  ID_BOOKMARK: string
  NAME: string
  EXTENT?: Extent
  POSITION?: Position
  CREATION_TIME?: TDateISO
  IS_FROM_ORGANIZATION?: boolean
}

export namespace Bookmark {
  export const fromBookmark = (bookmark: BookmarkType): Bookmark => {
    const newBookmark: Bookmark = {
      ID_BOOKMARK: bookmark.id,
      NAME: bookmark.name,
      CREATION_TIME: bookmark.creationTime?.toISOString()
    }
    if ('position' in bookmark) {
      newBookmark.POSITION = bookmark.position
    } else {
      newBookmark.EXTENT = bookmark.extent
    }
    return newBookmark
  }
}
